var $2422ac328687ee23$exports = {};
$2422ac328687ee23$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{412}\u{438}\u{431}\u{435}\u{440}\u{456}\u{442}\u{44C} \u{435}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}`,
    "tableResizer": `\u{417}\u{430}\u{441}\u{456}\u{431} \u{437}\u{43C}\u{456}\u{43D}\u{435}\u{43D}\u{43D}\u{44F} \u{440}\u{43E}\u{437}\u{43C}\u{456}\u{440}\u{443}`,
    "colorSwatchPicker": `Color swatches`
};


export {$2422ac328687ee23$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
